import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {
    PlaviNalog,
    PlaviNalogFormModel,
    PlaviNalogOperationWorker,
    PlaviNalogOperacija,
    PlaviNalogParams,
    PlaviNalogProductionAnalytics,
    PlaviNalogRadniciParams,
} from '../models/PlaviNalog'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/plavi-nalozi`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAll(params: PlaviNalogParams) {
    return await axios.get<Array<PlaviNalog>>(API, {headers: headers, params: params})
}

export async function get(id: number): Promise<Partial<PlaviNalog>> {
    const response = await axios.get(`${API}/${id}`, {headers: headers})
    return response.data?.data ?? response.data
}

export async function create(data: PlaviNalogFormModel) {
    const response = await axios.post(API, data, {headers: headers})
    return response.data
}

export async function update(id: number, data: PlaviNalogFormModel) {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, data, {headers: headers})
    return response.data
}

export async function deletePlaviNalog(id: number) {
    const response = await axios.delete(`${API}/${id}`, {headers: headers})
    return response.data
}

export async function pokreni(id: number) {
    const response = await axios.post(`${API}/${id}/pokreni`, {}, {headers: headers})
    return response.data
}

export async function zavrsi(id: number) {
    const response = await axios.post(`${API}/${id}/zavrsi`, {}, {headers: headers})
    return response.data
}

export async function operacije(id: number): Promise<Array<PlaviNalogOperacija>> {
    const response = await axios.get(`${API}/${id}/operacije`, {headers: headers})
    return response.data?.data ?? response.data
}

export async function radnici(id: number, params: PlaviNalogRadniciParams) {
    const response = await axios.get(`${API}/${id}/radnici`, {headers: headers, params: params})
    return response.data?.data ?? response.data
}

export async function getOperationWorkers(orderId: number, operationId: number): Promise<Array<PlaviNalogOperationWorker>> {
    const response = await axios.get(`${API}/${orderId}/operacije/${operationId}/radnici`, {headers: headers})
    return response.data?.data ?? response.data
}

export async function deleteOperacija(orderId: number, operationId: number) {
    const response = await axios.delete(`${API}/${orderId}/operacije/${operationId}`, {headers: headers})
    return response.data
}

export async function getProductionAnalytics(orderId: number): Promise<Array<PlaviNalogProductionAnalytics>> {
    const response = await axios.get(`${API}/${orderId}/analitika-radnika`, {headers: headers})
    return response.data?.data ?? response.data
}

export async function kontrolaNaloga(id: number, nalogKontrolisaoKomentar: string, nalogUredan: boolean) {
    const response = await axios.patch(
        `${API}/${id}/kontrola-naloga`,
        {nalogKontrolisaoKomentar, nalogUredan},
        {headers: headers}
    )
    return response.data
}

export async function ulazArtikla(id: number, tipUlaza: 'paletno' | 'protocni', ArtPaletaLokacija?: string) {
    const response = await axios.post(
        `${API}/${id}/ulaz-artikla`,
        {tipUlaza, ArtPaletaLokacija},
        {headers: headers}
    )
    return response.data
}

export async function pokreniOperaciju(id: number, idOperacije: number, data = {}) {
    const response = await axios.patch(`${API}/${id}/operacije/${idOperacije}/pokreni`, data, {headers: headers})
    return response.data
}

export async function zavrsiOperaciju(id: number, idOperacije: number, data = {}) {
    const response = await axios.patch(`${API}/${id}/operacije/${idOperacije}/zavrsi`, data, {headers: headers})
    return response.data
}
